<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4">
      <div>
        <h3 class="text-sm font-medium text-gray-900 flex items-center gap-2">
          <span>{{ memberName }}</span>
          <svg
            v-if="ownsAccount"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-5 text-green-600 inline-flex"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
            />
          </svg>
        </h3>
        <div class="mb-2">
          <div class="text-xs text-gray-600">Email: {{ memberEmailAddress }}</div>
          <div class="text-xs text-gray-600">Phone: {{ memberPhone }}</div>
        </div>
        <div class="flex flex-col items-start gap-2">
          <ImpersonateAction v-if="$isAdminOrSuperAdmin" :membership="membership" />
          <ActivateUserAction
            v-if="$isAdminOrSuperAdmin && membership.user.active === false"
            :user="membership.user"
            @activated="$emit('change')"
          />
        </div>
      </div>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">{{ roleName }}</td>
    <td class="px-4 py-4 w-0">
      <div v-if="!ownsAccount" class="flex gap-3 justify-end">
        <ChangeRoleAction
          v-if="$membershipHasPermissionTo('edit memberships')"
          :membership="membership"
          :role-options="roleOptions"
          @changed="$emit('change')"
        />
        <TransferOwnershipAction
          v-if="!customRole && (ownsAccount || $isAdminOrSuperAdmin)"
          :membership="membership"
          @transfered="$emit('change')"
        />
        <RemoveMemberAction
          v-if="$membershipHasPermissionTo('delete memberships')"
          :membership="membership"
          @removed="$emit('change')"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import ActivateUserAction from './ActivateUserAction.vue';
import ChangeRoleAction from './ChangeRoleAction.vue';
import ImpersonateAction from './ImpersonateAction.vue';
import RemoveMemberAction from './RemoveMemberAction.vue';
import TransferOwnershipAction from './TransferOwnershipAction.vue';

export default {
  components: {
    ImpersonateAction,
    ActivateUserAction,
    ChangeRoleAction,
    TransferOwnershipAction,
    RemoveMemberAction,
  },
  props: {
    membership: {
      type: Object,
      required: true,
    },
    roleOptions: {
      type: Array,
      default: () => [],
    },
    ownsAccount: Boolean,
  },
  computed: {
    memberName() {
      return this.membership?.user?.fullName || 'Unknown';
    },
    memberEmailAddress() {
      return this.membership?.user?.email || 'Uknown';
    },
    memberPhone() {
      return this.membership?.user?.phone || '-';
    },
    role() {
      return this.membership?.roles?.[0];
    },
    roleName() {
      return this.role?.name || 'Unknown role';
    },
    customRole() {
      return this.role?.custom;
    },
  },
};
</script>
